import {ReactComponent as Award} from 'src/assets/book/award.svg';
import {ReactComponent as Info} from 'src/assets/info.svg';
import {bookIntroCss} from '../css/Books.style'
import Like from "../../goods/components/like"
import {useIsMobile} from "../../../hooks/useIsMobile";
import React, { useState } from "react";
import { triggerConfetti } from 'src/hooks/useConfetti';
import {bookDelete} from "../../../api/index";
import {useNavigate} from "react-router-dom";
import Alert from "../../../common/layouts/modal/Alert";
import { motion, useScroll, useTransform } from "framer-motion";

interface getBookData {
    bookId : string;
    bookTitle: string;
    genre1?: string;
    genre2?: string;
    bookIndex?: string;
    bookPublicationReason?: string;
    coverImage?: string;
    bookDescription?: string;
    bookAwardTitle?: string;
    bookAwardDate?: string;
    likeCount?:number;
    like?: boolean,
    author: Author;
    testStatus : boolean;
    bookLink: string;
}

interface Author {
    authorName: string;
    authorEmail: string;
}

interface BookIntroProps {
    bookData: getBookData;
    onLike: () => void;
    authorYn : boolean;

}

interface ImageDataType {
    src: string;
    alt: string;
}

const BookIntro = ({ bookData, onLike, authorYn }: BookIntroProps) => {
    const { scrollY } = useScroll();
    const bookCoverParallax = useTransform(scrollY, [0, 600], [0, -40]);

    const authorStatus  : string | null = localStorage.getItem("authorStatus")

    const testYn = bookData.testStatus


    const navigate = useNavigate();
    const isMobile = useIsMobile();
    const { bookTitle, bookId,  bookIndex, bookPublicationReason, like, likeCount, genre1, genre2, coverImage, bookDescription,bookAwardTitle, bookAwardDate,author, bookLink  } = bookData;

    const { authorName } = author;
    const bookImg = coverImage ? `data:image/jpeg;base64,${coverImage}` : `${process.env.PUBLIC_URL}/img/book_5.jpg`;

    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [likeAlert, setLikeAlert] = useState<boolean>(false);



    const clickEdit = () => {
        navigate('/book/update', { state: { bookData } });
    };

    const clickDelete = async () => {
       const id= bookId;

        try {
            await bookDelete(id);
            navigate('/mypage')

        } catch (e) {
            console.error("Failed to delete book:", e);
        }
    }


    return (
        <>

            {isMobile ?
                <>


                    {authorYn && (
                        <div className={"flex flex-row gap-2 justify-end px-[20px] py-4"}>
                            <button
                                onClick={clickEdit}
                                className={"w-[66px] h-[30px] px-3 flex justify-center items-center bg-[#EAFBF3] rounded-full text-main font-namsan text-sm font-semibold"}>
                            수정
                            </button>
                            <button
                                onClick={() => setShowAlert(true)}
                                className={"w-[66px] h-[30px] px-3 flex justify-center items-center bg-[#fff2f2] rounded-full text-[#E53935] font-namsan text-sm font-semibold"}>
                                삭제
                            </button>
                        </div>
                    )}

                    {/* Mobile Hero */}
                    <div
                        className="relative overflow-hidden px-5 pt-6 pb-8"
                        style={{ background: 'linear-gradient(149deg, #f1f5f2 0%, #e8f5ee 100%)' }}
                    >
                        {testYn && (
                            <div className="w-full flex flex-row gap-1.5 justify-center items-center text-[#727272] text-xs font-normal pb-3">
                                <div className="flex w-3.5 h-3.5 items-center justify-center">
                                    <Info className="w-full h-full"/>
                                </div>
                                <span>이 페이지는 예시 데이터로 구성되었습니다.</span>
                            </div>
                        )}
                        {/* 블러 장식 */}
                        <div
                            className="absolute pointer-events-none"
                            style={{
                                width: 260,
                                height: 260,
                                borderRadius: '50%',
                                background: '#19CF7A',
                                filter: 'blur(80px)',
                                opacity: 0.22,
                                top: -60,
                                right: -60,
                            }}
                        />

                        <div className="relative z-10 flex flex-col gap-[26px]">
                            {/* 표지 */}
                            <motion.div
                                className="flex justify-center"
                                initial={{ opacity: 0, y: 32 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.7, ease: "easeOut" }}
                            >
                                <div className="w-[240px] h-[346px]">
                                    <img
                                        src={bookImg}
                                        alt="bookData"
                                        className="w-full h-full object-cover rounded-[14px] shadow-[0px_15px_40px_0px_rgba(0,0,0,0.25)] cursor-pointer"
                                    />
                                </div>
                            </motion.div>

                            <motion.div
                                className="flex flex-col gap-[6px]"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.65, delay: 0.2, ease: "easeOut" }}
                            >
                                {/* 수상 + 좋아요 */}
                                <div className="flex flex-row justify-between items-center mb-1">
                                    {bookAwardTitle ? (
                                        <div className="flex flex-row items-center gap-1.5">
                                            <Award className="w-[24px] h-[24px]" />
                                            <span className="text-[#657970] text-[14px] font-bold">{bookAwardTitle}</span>
                                            {bookAwardDate && (
                                                <span className="text-[#657970] text-[12px]">{bookAwardDate}</span>
                                            )}
                                        </div>
                                    ) : <div />}
                                    <div className="flex items-center gap-1.5">
                                        <div
                                            onMouseDown={(e) => {
                                                // 로그인 O, 본인 아님, 아직 좋아요 안 한 상태 → 폭죽
                                                if (authorStatus && !authorYn && !like) {
                                                    triggerConfetti(e, { count: 22, spread: 100, originY: -10 });
                                                }
                                            }}
                                        >
                                            <Like
                                                onClick={() => {
                                                    if (authorYn || !authorStatus) { setLikeAlert(true); return; }
                                                    onLike();
                                                }}
                                                liked={like}
                                            />
                                        </div>
                                        <span className="text-[16px] font-namsan text-[#f93535]">{likeCount}</span>
                                    </div>
                                </div>

                                {/* 제목 */}
                                <span className="text-[#14213D] text-[24px] font-bold leading-snug">{bookTitle}</span>

                                {/* 장르 */}
                                <div className="flex flex-row gap-1.5 mt-1">
                                    {genre1 && (
                                        <div className="flex justify-center items-center text-[#19cf7a] border border-[#19cf7a] px-3.5 py-1.5 rounded-[4px] font-namsan bg-white text-[14px]">
                                            {genre1}
                                        </div>
                                    )}
                                    {genre2 && (
                                        <div className="flex justify-center items-center text-[#19cf7a] border border-[#19cf7a] px-3.5 py-1.5 rounded-[4px] font-namsan bg-white text-[14px]">
                                            {genre2}
                                        </div>
                                    )}
                                </div>

                                {/* 출간 계기 */}
                                {bookPublicationReason && (
                                    <div className="flex flex-col gap-2 mt-3">
                                        <div className="flex flex-row gap-1.5 items-baseline">
                                            <span className="font-namsan-EB text-[18px] text-[#19cf7a]">{authorName}</span>
                                            <span className="font-namsan text-[16px] text-[#4F556D]">작가님의 작품 출간 계기</span>
                                        </div>
                                        <div className="bg-[rgba(255,255,255,0.8)] rounded-[16px] shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1),0px_1px_2px_0px_rgba(0,0,0,0.1)] px-5 pt-4 pb-4">
                                            <p className="font-namsan text-[#333] text-[14px] leading-[26px] text-left">
                                                {bookPublicationReason}
                                            </p>
                                        </div>
                                    </div>
                                )}

                            </motion.div>
                        </div>
                    </div>


                </>

                :

                <>

                    <div className={"max-w-[1200px] mx-auto w-full flex flex-col gap-3 pt-8"}>

                        {authorYn && (
                            <div className={"flex flex-row gap-2 justify-end px-[50px]"}>
                                <button
                                    onClick={clickEdit}
                                    className={"h-[46px] px-8 flex justify-center items-center bg-[#EAFBF3] rounded-full text-main font-namsan text-base font-bold whitespace-nowrap"}>
                                    수정
                                </button>
                                <button
                                    onClick={() => setShowAlert(true)}
                                    className={"h-[46px] px-8 flex justify-center items-center bg-[#fff2f2] rounded-full text-[#E53935] font-namsan text-base font-bold whitespace-nowrap"}>
                                    삭제
                                </button>
                            </div>
                        )}

                    <div css={bookIntroCss} className="relative overflow-hidden">
                        {testYn && (
                            <div className="w-full flex flex-row gap-1.5 justify-center items-center text-[#727272] text-base font-normal pb-4">
                                <div className="flex w-5 h-5 items-center justify-center">
                                    <Info className="w-full h-full"/>
                                </div>
                                <span>이 페이지는 예시 데이터로 구성되었습니다.</span>
                            </div>
                        )}
                        {/* decorative blur blob */}
                        <div
                            className="absolute pointer-events-none rounded-full"
                            style={{
                                width: 400,
                                height: 400,
                                background: '#19CF7A',
                                filter: 'blur(87px)',
                                opacity: 0.22,
                                top: -120,
                                right: -50,
                                zIndex: 0,
                            }}
                        />

                        <div className="introWrap relative z-10">
                            {/* 책 표지: 패럴랙스 + 틸트 + 호버 확대 */}
                            <div className="bookImg">
                                <motion.div
                                    style={{ y: bookCoverParallax, width: '100%', height: '100%' }}
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    whileHover={{ scale: 1.04, transition: { duration: 0.18, ease: "easeOut" } }}
                                    transition={{ duration: 0.9, ease: "easeOut" }}
                                >
                                    <img src={bookImg} alt="bookData" className="rounded-md shadow-book cursor-pointer"/>
                                </motion.div>
                            </div>

                            {/* info 영역: 컨테이너 x:50 슬라이드인 + 내부 stagger */}
                            <motion.div
                                className="infoWrap"
                                initial={{ opacity: 0, x: 50 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.75, delay: 0.15, ease: "easeOut" }}
                            >
                                <div className={"flex flex-col gap-6"}>
                                    {/* 수상: scale(0.8) → scale(1) */}
                                    {bookAwardTitle && (
                                        <motion.div
                                            className="flex flex-row items-center gap-2"
                                            initial={{ opacity: 0, scale: 0.8 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            transition={{ duration: 0.5, delay: 0.35, ease: "easeOut" }}
                                        >
                                            <Award/>
                                            <span className="awardTilte">{bookAwardTitle}</span>
                                            <span className="awardDate">{bookAwardDate}</span>
                                        </motion.div>
                                    )}

                                    {/* 제목: y:20 → 0 */}
                                    <motion.div
                                        className="flex flex-row"
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.55, delay: bookAwardTitle ? 0.5 : 0.35, ease: "easeOut" }}
                                    >
                                        <span className="bookTitle">{bookTitle}</span>
                                    </motion.div>

                                    {/* 좋아요: opacity 진입 + 호버 시 왼쪽 슬라이드 */}
                                    <motion.div
                                        className="flex flex-row items-center w-fit cursor-pointer"
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        whileHover={{ x: -5, transition: { duration: 0.18, ease: "easeOut" } }}
                                        transition={{ duration: 0.5, delay: bookAwardTitle ? 0.65 : 0.5, ease: "easeOut" }}
                                        onMouseDown={(e) => {
                                            if (authorStatus && !authorYn && !like) {
                                                triggerConfetti(e, { count: 22, spread: 100, originY: -10 });
                                            }
                                        }}
                                        onClick={() => {
                                            if (authorYn || !authorStatus) {
                                                setLikeAlert(true);
                                                return;
                                            }
                                            onLike();
                                        }}
                                    >
                                        <Like liked={like} />
                                        <span className="ml-1 text-sm font-normal">{likeCount}</span>
                                    </motion.div>

                                    {/* 장르: y:20 → 0 진입 + 호버 시 각 태그 확대 */}
                                    <motion.div
                                        className="flex flex-row gap-2"
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.55, delay: bookAwardTitle ? 0.75 : 0.6, ease: "easeOut" }}
                                    >
                                        {genre1 && (
                                            <motion.div
                                                className="genre"
                                                whileHover={{ scale: 1.08 }}
                                                transition={{ type: "spring", stiffness: 500, damping: 25 }}
                                            >
                                                {genre1}
                                            </motion.div>
                                        )}
                                        {genre2 && (
                                            <motion.div
                                                className="genre"
                                                whileHover={{ scale: 1.08 }}
                                                transition={{ type: "spring", stiffness: 500, damping: 25 }}
                                            >
                                                {genre2}
                                            </motion.div>
                                        )}
                                    </motion.div>

                                    {/* 출간 계기: y:20 → 0 */}
                                    <motion.div
                                        className="flex flex-col gap-4 mt-6"
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.55, delay: bookAwardTitle ? 0.9 : 0.75, ease: "easeOut" }}
                                    >
                                        <div className="flex flex-row gap-1">
                                            <span className="authorName">{authorName}</span>
                                            <span className="authorResonTilte">작가님의 작품 출간 계기</span>
                                        </div>
                                        <div className="authorReson">
                                            <span>{bookPublicationReason}</span>
                                        </div>
                                    </motion.div>

                                    {/* {bookLink && (
                                        <PurchaseButton url={bookLink} />
                                    )} */}
                                </div>
                            </motion.div>
                        </div>


                    </div>

                    </div>

                </>




            }



            {showAlert && (
                <Alert
                    title=""
                    message={"해당 작품을 삭제하시겠습니까?"}
                    onConfirm={clickDelete}
                    onClose={() => setShowAlert(false)}
                />
            )}


            {likeAlert && (
                <Alert
                    title={!authorStatus ? "로그인이 필요해요" : "알림"}
                    message={!authorStatus ? "작품을 좋아요하려면\n로그인이 필요합니다." : "본인 작품은 좋아요할 수 없습니다."}
                    onClose={() => setLikeAlert(false)}
                    showLoginOnConfirm={!authorStatus}
                />
            )}


        </>


    )
}

interface PurchaseButtonProps {
    url: string;
    isMobile?: boolean;
}

const PurchaseButton = ({ url, isMobile }: PurchaseButtonProps) => {
    return null; // 제거됨
};

export default BookIntro;
